export function getCssRulesLength(sheet) {
  var rule = ('insertRule' in sheet) ? sheet.cssRules : sheet.rules;
  return rule.length;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/getCssRulesLength.js
// module id = 850
// module chunks = 2